import React, { Component } from 'react';

import MinCustomForm from '../Utils/MinCustomForm';

class ManageDevis extends Component {
  state = {
    managing: '0'
  };

  options = [
    { value: '0', label: 'à moi' },
    { value: '1', label: 'à l\'auteur' }
  ];

  handleChange = e => {
    this.props.setManaging(Number(e.target.value));
    this.setState({ managing: e.target.value });
  }

  render() {
    return <MinCustomForm
      title="Attribuer ce devis"
      value={this.state.managing}
      handleChange={this.handleChange}
      options={this.options}
      inline />;
  }
}

export default ManageDevis;
